import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const TasksIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x=".65" y=".65" width="12.7" height="11.7" rx="1.35" stroke={color} strokeWidth="1.3" />
    <path d="M4 5.714L6.5 8 10 4" stroke={color} strokeWidth="1.3" />
  </svg>
);

TasksIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

TasksIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(15, 13),
};

export default TasksIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/tasks.js